import successGif from "assets/gif/success.gif";
import ButtonOutline from "components/Semantic/ButtonOutline";
import { useNavigate, useParams } from "react-router-dom";

export const PaymentSuccess = () => {
  const navigate = useNavigate();
  const param: any = useParams();

  return (
    <div className="flex justify-center items-center">
      <div className="w-full max-w-md">
        <div className="w-full flex flex-col justify-center items-center px-6 py-10 gap-4  rounded-xl md:rounded-2xl border-[1px] border-[#E4E6F2] shadow-xl">
          <img src={successGif} alt="Success" className="mb-2" />
          <div className="text-center">
            <p className="font-extrabold text-2xl text-[#00BF8B] leading-snug sm:text-xl">Congratulations!</p>
            <p className="text-base font-medium text-[#5F5F5F] mt-1 sm:text-sm">Explore HCR results now</p>
          </div>
          <ButtonOutline title="GO TO HCR RESULT" className="w-full sm:w-auto mt-4" onClick={() => navigate(`/hcr/claim-form/${param?.id}`)} />
        </div>
      </div>
    </div>
  );
};
